var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64959 9.96639L6.99999 7.61679L9.35039 9.96639L9.96639 9.35039L7.61679 6.99999L9.96639 4.64959L9.35039 4.03359L6.99999 6.38319L4.64959 4.03359L4.03359 4.64959L6.38319 6.99999L4.03359 9.35039L4.64959 9.96639ZM6.99999 13.0664C6.16693 13.0664 5.38079 12.9083 4.64159 12.592C3.90293 12.2752 3.25839 11.8419 2.70799 11.292C2.15813 10.7416 1.72479 10.0971 1.40799 9.35839C1.09173 8.61919 0.933594 7.83306 0.933594 6.99999C0.933594 6.15573 1.09173 5.36693 1.40799 4.63359C1.72479 3.90026 2.15813 3.25839 2.70799 2.70799C3.25839 2.15813 3.90293 1.72479 4.64159 1.40799C5.38079 1.09173 6.16693 0.933594 6.99999 0.933594C7.84426 0.933594 8.63306 1.09173 9.36639 1.40799C10.0997 1.72479 10.7416 2.15813 11.292 2.70799C11.8419 3.25839 12.2752 3.90026 12.592 4.63359C12.9083 5.36693 13.0664 6.15573 13.0664 6.99999C13.0664 7.83306 12.9083 8.61919 12.592 9.35839C12.2752 10.0971 11.8419 10.7416 11.292 11.292C10.7416 11.8419 10.0997 12.2752 9.36639 12.592C8.63306 12.9083 7.84426 13.0664 6.99999 13.0664Z",
    fill: "#EF476F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.31b07f4195b432bffe61e1782235910c.svg";
export { ForwardRef as ReactComponent };